import { useSyncExternalStore } from 'react';

const MAX_LANDSCAPE_HEIGHT = 425;
const query = '(orientation: landscape)';

function subscribeToLandscape(callback: () => void) {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', callback);
  window.addEventListener('resize', callback);

  return () => {
    mql.removeEventListener('change', callback);
    window.removeEventListener('resize', callback);
  };
}

function getLandscapeSnapshot() {
  return window.matchMedia(query).matches && window.innerHeight < MAX_LANDSCAPE_HEIGHT;
}

export function useIsLandscape() {
  return useSyncExternalStore(subscribeToLandscape, getLandscapeSnapshot);
}
